import { lazy, Suspense, type ComponentType } from "react";
import type { RouteObject } from "react-router-dom";
import RequireAuth from "../components/auth/RequireAuth";

const HomePage = lazy(() => import("../pages/home/page"));
const MentorPage = lazy(() => import("../pages/mentor/page"));
const MentorsPage = lazy(() => import("../pages/mentors/page"));
const CoursesPage = lazy(() => import("../pages/courses/page"));
const CourseDetailPage = lazy(() => import("../pages/course/page"));
const CourseStudyPage = lazy(() => import("../pages/course/study"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const BlogDetailPage = lazy(() => import("../pages/blog/detail"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const LoginPage = lazy(() => import("../pages/auth/login"));
const RegisterPage = lazy(() => import("../pages/auth/register"));
const AccountPage = lazy(() => import("../pages/account/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const LegalPage = lazy(() => import("../pages/legal/page"));

function withSuspense(Page: ComponentType) {
  return (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  );
}

const routes: RouteObject[] = [
  { path: "/", element: withSuspense(HomePage) },
  { path: "/mentors", element: withSuspense(MentorsPage) },
  { path: "/mentor/:mentorId", element: withSuspense(MentorPage) },
  { path: "/courses", element: withSuspense(CoursesPage) },
  { path: "/course/:courseId", element: withSuspense(CourseDetailPage) },
  {
    path: "/course/:courseId/study",
    element: <RequireAuth>{withSuspense(CourseStudyPage)}</RequireAuth>,
  },
  { path: "/services", element: withSuspense(ServicesPage) },
  { path: "/blog", element: withSuspense(BlogPage) },
  { path: "/blog/:postId", element: withSuspense(BlogDetailPage) },
  { path: "/contact", element: withSuspense(ContactPage) },
  {
    path: "/account",
    element: <RequireAuth>{withSuspense(AccountPage)}</RequireAuth>,
  },
  { path: "/legal", element: withSuspense(LegalPage) },
  { path: "/login", element: withSuspense(LoginPage) },
  { path: "/register", element: withSuspense(RegisterPage) },
  { path: "*", element: withSuspense(NotFound) },
];

export default routes;
